var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScheduledJob = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 8V14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14V8C10 7.44772 9.55228 7 9 7C8.44772 7 8 7.44772 8 8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8V14C12 14.5523 12.4477 15 13 15C13.5523 15 14 14.5523 14 14V8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
})));
export default SvgScheduledJob;